/* Amara Belle product row behaviour. Shared by every tm-recommendations section.
   Handles: the carousel arrows and the recently viewed row. */
(function () {
  var RV_KEY = 'ab_recently_viewed';
  var RV_MAX = 24;

  /* ---------- recently viewed store ---------- */

  function rvRead() {
    try {
      var raw = window.localStorage.getItem(RV_KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }

  function rvRecord(handle) {
    if (!handle) return;
    try {
      var list = rvRead().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      window.localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX)));
    } catch (e) {}
  }

  /* ---------- card building ---------- */

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function img(src, width) {
    if (!src) return '';
    return src.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + width + 'x$1$2');
  }

  function buildCard(p, opts) {
    var hover = p.images && p.images.length > 1 ? p.images[1] : null;
    var onSale = p.compare_at_price && p.compare_at_price > p.price;

    var a = document.createElement('a');
    a.className = 'ah-recs__card' + (hover ? ' has-hover' : '');
    a.href = p.url || ('/products/' + p.handle);

    var media = document.createElement('div');
    media.className = 'ah-recs__media';

    if (onSale && opts.showBadge) {
      var badge = document.createElement('span');
      badge.className = 'ah-recs__badge';
      badge.textContent = opts.badgeText;
      media.appendChild(badge);
    }

    var primary = p.featured_image || (p.images && p.images[0]);
    if (primary) {
      var i1 = document.createElement('img');
      i1.className = 'ah-recs__img ah-recs__img--primary';
      i1.src = img(primary, 700);
      i1.alt = p.title || '';
      i1.loading = 'lazy';
      i1.width = 700; i1.height = 875;
      media.appendChild(i1);
    }
    if (hover) {
      var i2 = document.createElement('img');
      i2.className = 'ah-recs__img ah-recs__img--hover';
      i2.src = img(hover, 700);
      i2.alt = '';
      i2.setAttribute('aria-hidden', 'true');
      i2.loading = 'lazy';
      i2.width = 700; i2.height = 875;
      media.appendChild(i2);
    }
    a.appendChild(media);

    var info = document.createElement('div');
    info.className = 'ah-recs__info';

    var title = document.createElement('span');
    title.className = 'ah-recs__title';
    title.textContent = p.title || '';
    info.appendChild(title);

    var prices = document.createElement('span');
    prices.className = 'ah-recs__prices';
    if (onSale) {
      var now = document.createElement('span');
      now.className = 'ah-recs__price ah-recs__price--sale';
      now.textContent = money(p.price, opts.currency);
      var was = document.createElement('span');
      was.className = 'ah-recs__price ah-recs__price--was';
      was.textContent = money(p.compare_at_price, opts.currency);
      prices.appendChild(now); prices.appendChild(was);
    } else {
      var only = document.createElement('span');
      only.className = 'ah-recs__price';
      only.textContent = money(p.price, opts.currency);
      prices.appendChild(only);
    }
    info.appendChild(prices);
    a.appendChild(info);
    return a;
  }

  /* ---------- recently viewed row ---------- */

  function initRecentlyViewed(host) {
    var current = host.dataset.currentHandle || '';
    var limit = parseInt(host.dataset.limit, 10) || 12;
    var opts = {
      showBadge: host.dataset.showBadge === 'true',
      badgeText: host.dataset.badgeText || 'Sale',
      currency: host.dataset.currency || 'USD'
    };

    var handles = rvRead().filter(function (h) { return h !== current; }).slice(0, limit);
    if (current) rvRecord(current);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var live = products.filter(function (p) { return p && p.available !== false; });
      if (!live.length) return;

      var track = host.querySelector('[data-ah-track]');
      if (!track) return;
      track.innerHTML = '';
      live.forEach(function (p) { track.appendChild(buildCard(p, opts)); });
      host.hidden = false;
    });
  }

  /* ---------- carousel arrows ---------- */

  function initCarousel(host) {
    function track() { return host.querySelector('[data-ah-track]'); }

    function pageWidth(t) {
      var card = t.querySelector('.ah-recs__card') || t.querySelector('.ah-recs__skeleton');
      var gap = parseFloat(window.getComputedStyle(t).columnGap) || 0;
      if (!card) return t.clientWidth;
      var w = card.getBoundingClientRect().width;
      var per = Math.max(1, Math.floor((t.clientWidth + gap) / (w + gap)));
      return (w + gap) * per;
    }

    function sync() {
      var t = track();
      if (!t) return;
      var prev = host.querySelector('[data-ah-prev]');
      var next = host.querySelector('[data-ah-next]');
      if (!prev || !next) return;
      var max = t.scrollWidth - t.clientWidth;
      var scrollable = max > 4;
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft >= max - 2;
    }

    host.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-ah-prev],[data-ah-next]') : null;
      if (!btn) return;
      var t = track();
      if (!t) return;
      var dir = btn.hasAttribute('data-ah-prev') ? -1 : 1;
      t.scrollBy({ left: dir * pageWidth(t), behavior: 'smooth' });
    });

    var ticking = false;
    host.addEventListener('scroll', function (e) {
      var el = e.target;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-ah-track')) return;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, true);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(sync, 200);
    });

    var mo = new MutationObserver(function () { sync(); });
    mo.observe(host, { childList: true, subtree: true });

    sync();
    window.addEventListener('load', sync);
  }

  /* ---------- automatic recommendations ---------- */

  function initRelated(host) {
    if (host.getAttribute('data-recommendations-performed') === 'true') return;
    if (host.dataset.ahRelated === '1') return;
    host.dataset.ahRelated = '1';

    var sid = host.getAttribute('data-section-id');
    var pid = host.getAttribute('data-product-id');
    var limit = host.getAttribute('data-limit') || '12';
    if (!sid || !pid) return;

    var url = '/recommendations/products?section_id=' + encodeURIComponent(sid) +
      '&product_id=' + encodeURIComponent(pid) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=related';

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.ah-recs-host');
        if (!next) return;
        if (!next.querySelector('.ah-recs__card')) { host.hidden = true; return; }
        host.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- boot ---------- */

  function boot(host) {
    if (!host || host.dataset.ahInit === '1') return;
    host.dataset.ahInit = '1';
    if (host.dataset.source === 'recently_viewed') initRecentlyViewed(host);
    if (host.dataset.source === 'related') initRelated(host);
    initCarousel(host);
  }

  function bootAll(scope) {
    var el = scope || document;
    if (el.dataset && el.dataset.source && el.classList && el.classList.contains('ah-recs-host')) boot(el);
    el.querySelectorAll('.ah-recs-host').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
})();
